export interface ITruckOdometer {
  id?: number | null;
  truckImplementId?: number | null;
  totalOdometer?: string | number | null;
  updatedAt?: string | null;
}

export const defaultValue: Readonly<ITruckOdometer> = {};
